import { Model, PoweredBy, IDataArray, Document, DataArray, Project, Minesite, EquipmentDocuments } from './../../shared/index';

export class Equipment implements IDataArray {
    public Id = 0;
    public Serial: string;
    public PoweredById: number;
    public ModelId: number;
    public Active: boolean;
    public MinesiteId: number;
    public BaseLanguage: string;
    public Created: Date;
    public Modified: Date;
    public Equipment_ID: number;
    public Associated_ID: number;
    public Model: Model = new Model();
    public PoweredBy: PoweredBy = new PoweredBy();
    public Minesite: Minesite | null;
    public Project: Project = new Project();
    public Status: number;
    public Is_Changed: boolean;
    public DocumentCount = 0;
    public PartsManualURL: string;
    public EDManualURL: string;

    public GetById(): number {
        return this.Id != 0 && this.Id != undefined ? this.Id : this.Equipment_ID;
    }
}
